export enum CleanupSource {
    CONFIRM_ORDER_FAIL = "CONFIRM_ORDER_FAIL",
    CONFIRM_ORDER_SUCCESS = "CONFIRM_ORDER_SUCCESS",
    APP_WEBVIEW_STATE_EMPTY = "APP_WEBVIEW_STATE_EMPTY",
}

export enum SetDataSource {
    VPA_TIMER = "VPA_TIMER",
    PROCESS_ORDER = "PROCESS_ORDER",
    UPI_POLLER = "UPI_POLLER",
}

export enum PSRMetricSource {
    CONFIRM_ORDER_SUCCESS = "CONFIRM_ORDER_SUCCESS",
    CONFIRM_ORDER_FAILURE = "CONFIRM_ORDER_FAILURE",
}
